/** 接口无 download 时的默认完整落地页地址（含 hash 路由） */
export const DEFAULT_LANDING_STATIC =
  process.env.REACT_APP_LANDING_URL ||
  "http://172.16.1.144:5173/#/ty?agent=1590233";

function isIpOrLocalhost(host) {
  return (
    host === "localhost" ||
    /^(\d{1,3}\.){3}\d{1,3}$/.test(host)
  );
}

/**
 * 从 download 主机名截取主域名
 * 例：hx12342222.baodingzqt.com → baodingzqt.com
 */
export function extractMainDomain(hostname) {
  if (!hostname || typeof hostname !== "string") return "";
  const host = hostname.trim().toLowerCase();
  if (isIpOrLocalhost(host)) return host;
  const parts = host.split(".").filter(Boolean);
  if (parts.length <= 2) return host;
  return parts.slice(-2).join(".");
}

/**
 * /api/v1/latestAddress 字段 download：落地页地址
 */
export function pickLandingStatic(data) {
  if (!data || typeof data !== "object") return DEFAULT_LANDING_STATIC;
  const v = data.download ?? data.Download;
  const s = v == null ? "" : String(v).trim();
  return s || DEFAULT_LANDING_STATIC;
}
